'use client'

import React from 'react'
import { AppLayout } from '@/components/AppLayout'
import { PinUpdateIntro } from '@/components/PinUpdateIntro'
import { PinUpdate } from '@/components/PinUpdate'
import { Spinner, Text } from 'tamagui'
import { useDataStore } from '@/contexts/DataStoreContext'
import { ErrorState } from '@/components/ErrorState'

export default function App() {

  const {
    session: { data, error, isLoading },
    showPinIntro
   } = useDataStore()

  return (
    <AppLayout>
      {
        isLoading ? <Spinner size="large" color="gray"/> :
        error ? <ErrorState /> :
        showPinIntro ? <PinUpdateIntro /> :
        <PinUpdate />
      }
    </AppLayout>
  )
}

// TODO: add login handling here